// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","title":"rye8n3-vuigHw9JxbJ9Zm _2IbHD4FVxtBnbNHEUw2mS3","subheader":"_3tfkBLzh4oNF67_ojQV2Pn","container":"_3HRPsUPBA4tgOkMikTY1e4 _15-uIrn7gODHiOpUuDWjwC","mainContent":"VosXf2bds0avig92VakFF _2ELtkcMpIJZ1yyH_kfj3I7","titleContainer":"_1RWUpjGffUxhIExzllpFIJ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/information-menu-mobile/InformationMenuMobile.css
// module id = 1143
// module chunks = 2